<script lang="ts">
import layout from '~/consumer/layouts/DefaultLayout.vue'
export default { layout }

</script>
<script lang="ts" setup>
import TermsPage from '@consumer/modules/legal/TermsPage.vue'
</script>

<template>
  <TermsPage/>
</template>
